import script from "./DoAnswerView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoAnswerView.vue?vue&type=script&setup=true&lang=ts"

import "./DoAnswerView.vue?vue&type=style&index=0&id=13b455f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b455f4"]])

export default __exports__